module.exports = __webpack_public_path__ + "img/Donate.9aefd77c.png";